var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { createBrowserHistory } from "history";
import React, { useContext, useEffect, useState } from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import { ThemeProvider } from "styled-components";
import configureStore from "./store";
import AppRoutes from "./AppRoutes";
import { CookiesProvider } from "react-cookie";
import { WidgetContext } from "./components/Widget";
import { LoadScript } from "@react-google-maps/api";
import AnalyticsProvider from "./AnalyticsProvider";
import EntryQueue from "./EntryQueue";
import AppListener from "./AppListener";
import CookieWarning from "./components/Pages/CookieWarning/CookieWarning";
import { localTest } from "./data/localStorageHelpers";
export var history = createBrowserHistory();
export var FooterVisibility;
(function (FooterVisibility) {
    FooterVisibility[FooterVisibility["show"] = 0] = "show";
    FooterVisibility[FooterVisibility["hide"] = 1] = "hide";
    FooterVisibility[FooterVisibility["default"] = 2] = "default";
})(FooterVisibility || (FooterVisibility = {}));
export var AppFormContext = React.createContext({
    formikContext: undefined,
    setFormikContext: undefined,
    footerVisibility: FooterVisibility.default,
    setFooterVisibility: undefined,
});
var googleMapLibraries = ["places"];
var App = function (_a) {
    var context = _a.context, theme = _a.theme, isWidget = _a.isWidget;
    var _b = __read(useState(), 2), store = _b[0], setStore = _b[1];
    var _c = __read(useState(), 2), formikContext = _c[0], setFormikContext = _c[1];
    var _d = __read(useState(FooterVisibility.default), 2), footerVisibility = _d[0], setFooterVisibility = _d[1];
    var _e = __read(useState(), 2), persistor = _e[0], setPersistor = _e[1];
    var flatTheme = Object.assign({}, theme);
    useEffect(function () {
        var _a = configureStore(history), store = _a.store, persistor = _a.persistor;
        setStore(store);
        setPersistor(persistor);
    }, []);
    var darkMode = useContext(WidgetContext).darkMode;
    var router = function (allowAccess) {
        return _jsx(AppRoutes, { theme: theme, isWidget: isWidget, allowAccess: allowAccess });
    };
    if (!store || !persistor) {
        return null;
    }
    // cookies check
    if (!localTest()) {
        return _jsx(CookieWarning, {});
    }
    var loadLocalFontAwesome = function () {
        if (window.brushfireDebugMode === true || window.brushfireDebugMode === "true") {
            console.log("Loading local FontAwesome", process.env.REACT_APP_DOMAIN);
        }
        var localFA = document.createElement("link");
        localFA.rel = "stylesheet";
        localFA.href = "https://app.".concat(process.env.REACT_APP_DOMAIN, "/fonts/fontawesome/css/all.min.css");
        document.head.appendChild(localFA);
    };
    var handleHelmetClientStateChange = function (newState, addedTags, removedTags) {
        var _a;
        if (addedTags && ((_a = addedTags.scriptTags) === null || _a === void 0 ? void 0 : _a.find(function (x) { var _a; return (_a = x.src) === null || _a === void 0 ? void 0 : _a.includes("kit.fontawesome.com"); }))) {
            addedTags.scriptTags.find(function (x) { var _a; return (_a = x.src) === null || _a === void 0 ? void 0 : _a.includes("kit.fontawesome.com"); }).onerror = loadLocalFontAwesome;
        }
    };
    return (_jsx(Provider, __assign({ store: store }, { children: _jsx(PersistGate, __assign({ loading: null, persistor: persistor }, { children: _jsx(AppFormContext.Provider, __assign({ value: { formikContext: formikContext, setFormikContext: setFormikContext, footerVisibility: footerVisibility, setFooterVisibility: setFooterVisibility } }, { children: _jsx(ThemeProvider, __assign({ theme: flatTheme }, { children: _jsx(CookiesProvider, { children: _jsx(HelmetProvider, { children: _jsx(AnalyticsProvider, __assign({ isWidget: isWidget, debugMode: window.brushfireDebugMode === true || window.brushfireDebugMode === "true" }, { children: _jsxs(LoadScript, __assign({ googleMapsApiKey: "AIzaSyAEb4ZK_b0uWGt-CsKJcxTWWhYmClc47_c", libraries: googleMapLibraries, loadingElement: _jsx(_Fragment, {}) }, { children: [_jsxs(BrowserRouter, { children: [_jsx(AppListener, {}), _jsx(EntryQueue, __assign({ isWidget: isWidget }, { children: function (allowAccess) { return router(allowAccess); } }))] }), _jsxs(Helmet, __assign({ onChangeClientState: handleHelmetClientStateChange }, { children: [_jsx("html", { className: darkMode ? "dark" : "light" }), _jsx("script", { src: "https://kit.fontawesome.com/82cd8eff64.js" }), _jsx("script", { children: "(function(h,o,t,j,a,r){\n\t\t\t\t\t\t\t\t\t\t\t\t\th.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};\n\t\t\t\t\t\t\t\t\t\t\t\t\th._hjSettings={hjid:3113089,hjsv:6};\n\t\t\t\t\t\t\t\t\t\t\t\t\ta=o.getElementsByTagName('head')[0];\n\t\t\t\t\t\t\t\t\t\t\t\t\tr=o.createElement('script');r.async=1;\n\t\t\t\t\t\t\t\t\t\t\t\t\tr.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;\n\t\t\t\t\t\t\t\t\t\t\t\t\ta.appendChild(r);\n\t\t\t\t\t\t\t\t\t\t\t\t})(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');" })] }))] })) })) }) }) })) })) })) })));
};
export default App;
